module.exports = __webpack_public_path__ + "img/29.e3db673f.jpg";